import { Partner } from '../../../../../entities/applicant_tracking/jobboards/Partner';
import { ApiService } from '../../../../ApiService';

export class PartnerService {
  public static get(): Promise<Partner> {
    return ApiService.get('/api/v1/applicant_tracking/job_boards/partner');
  }
}
